import { CheckoutService } from './../../../../../../_services/checkout.service';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { OrderService, AuthenticationService, SiteService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { Payments } from '@app/_models';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BenefitPayDialogComponent } from '@app/shared/components/benefit-pay-dialog/benefit-pay-dialog.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import * as _ from 'lodash';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { CancelProfessionalDialogComponent } from './componenet/cancel-order-dialog/cancel-order-dialog.component';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { PayProfessionalDialogComponent } from './componenet/pay-professional-dialog/pay-professional-dialog.component';
import { CurrencyFormatPipe } from '../../../../../../shared/pipes/currency-format.pipe';
import { MatTabsModule } from '@angular/material/tabs';
import { OptionsDetailsViewerComponent } from '../../../../../../shared/components/options-details/options-details.component';
import { CancelOrderInformationComponent } from '../order-details/componenet/cancel-order-information/cancel-order-information.component';
import { MatDividerModule } from '@angular/material/divider';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { BookingLineSummaryComponent } from '@app/shared/components/booking-line-summary/booking-line-summary.component';
import { WorkOrderLine } from '@interfaces/professional-booking';


@Component({
    selector: 'app-professional-order-details',
    templateUrl: './professional-order-details.component.html',
    styleUrls: ['./professional-order-details.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, RouterLink, MatDividerModule, CancelOrderInformationComponent, NgFor, OptionsDetailsViewerComponent, MatTabsModule, DatePipe, CurrencyFormatPipe, TranslateModule,
        BookingLineSummaryComponent]
})
export class professionalOrderDetailsComponent {
    constructor(private route: ActivatedRoute,
        private orderService: OrderService,
        private authService: AuthenticationService,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private httpClient: HttpClient,
        private modalService: BsModalService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private checkoutService: CheckoutService,
        public siteService: SiteService) { }


    @Input() order;
    @Input() isGuest;
    orderId;
    userDetails;
    paidStatuses = Payments.getPaidStatuses();
    bsModalRef: BsModalRef;

    @ViewChild('overlay') overlay: ElementRef;

    /** The booked service's own page; the line's `_id` is the service id, which the item route accepts. */
    serviceLink(line: WorkOrderLine): string[] {
        const profession = this.order?.professionalData?.profession;
        return [`/${this.translate.currentLang}`, 'professional', profession?.seo?.slug || profession?._id, line._id];
    }

    ngOnInit(): void {
        this.authService.currentUser.subscribe(user => {
            this.userDetails = user;
        });
        this.route.params.subscribe((params) => {
            this.orderId = params['orderId'];
        });

    }

    printOrder() {
        return this.orderService.printOrderUrl(this.orderId);
    }
    payWithBenefit(){
        const initialState = {
            order: this.order
        };
        this.bsModalRef = this.modalService.show(BenefitPayDialogComponent, {
            initialState, ignoreBackdropClick: true
        });
    }

    cancelRequest() {
        this.orderService.cancelOrder({})
    }

    openCancelDialog() {

        this.dialog.open(CancelProfessionalDialogComponent, { data: this.order }).afterClosed().subscribe(value => {
            if (value) {
                this.orderService.cancelOrder(value, 'work-order').subscribe((res=>{
                    if (res.code == 200) {
                        this.order = res.data;
                        this.toastr.show(res.msg);
                    }
                    else this.toastr.error(res.msg || "Error cancelling Order.");
                }))
            }
        });
    }

    selectedChange(tab) {
        if (tab != 1 || !this.order?.unreadUserMessages) return;
        this.orderService.readCommunications(this.order?.orderId).subscribe((response)=>{
            if (response.code == 200) this.order.unreadUserMessages = false;
        });
    }

}
